import Card from "../components/UI/Card";
import { Fragment, useEffect } from "react";

import Photos from "../components/Gallery/Photos";

const Gallery = (props) => {
  useEffect(() => {
    document
      .getElementById("top")
      .scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <Fragment>
      <p className="main" id="top"></p>
      <Card>
        <div>
          <h1>Gallery</h1>
        </div>
      </Card>
      <Photos photos={props.photos} />
    </Fragment>
  );
};

export default Gallery;
